module.exports = __webpack_public_path__ + "static/media/time_report.ed6df19e.svg";